import { render } from "./TextVerticalAlign.vue?vue&type=template&id=05748584&scoped=true"
import script from "./TextVerticalAlign.vue?vue&type=script&lang=js"
export * from "./TextVerticalAlign.vue?vue&type=script&lang=js"

import "./TextVerticalAlign.vue?vue&type=style&index=0&id=05748584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05748584"]])

export default __exports__